const page1 = [
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "Creme Brulee Earl Grey Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/White-Chocolate-Peppermint-Herbal-circle-trans.png?v=1708034511&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/White-Chocolate-Peppermint-Herbal-circle-trans.png?v=1708034511&width=239 239w,",
    "name": "White Chocolate Peppermint Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Spicy-Caramel-Apple-Herbal-Tea-circle-trans.png?v=1729632742&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Spicy-Caramel-Apple-Herbal-Tea-circle-trans.png?v=1729632742&width=239 239w,",
    "name": "Spicy Caramel Apple Cinnamon Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "Vanilla Sugar Cookie Herbal Dessert Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Peach-Bellini-Herbal-circle.png?v=1684779474&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Peach-Bellini-Herbal-circle.png?v=1684779474&width=239 239w,",
    "name": "Peach Bellini Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "The Self Care Blend (Elderberry - Apricot)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Full-Moon-Chai-Tea-circle.png?v=1687225062&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Full-Moon-Chai-Tea-circle.png?v=1687225062&width=239 239w,",
    "name": "Full Moon Chai (Vanilla Butternut Masala Chai)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Buttery Shortbread Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "Peaches 'n' Cream Oolong Tea (Peach-Vanilla)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "Gratitude Blend (Strawberry Earl Grey)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Tranquil-Peach-Herbal-Tea-circle.png?v=1687899042&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Tranquil-Peach-Herbal-Tea-circle.png?v=1687899042&width=239 239w,",
    "name": "Tranquil Peach Herbal Tea (Pineapple - Peach - Chamomile)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Citrus-Mint-Green-circle-trans.png?v=1711585131&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Citrus-Mint-Green-circle-trans.png?v=1711585131&width=239 239w,",
    "name": "Citrus Mint Green Tea (Lemon - Orange - Lemongrass - Mint)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Decaf-Toasted-Marshmallow-Black-Tea-circle.png?v=1687903606&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Decaf-Toasted-Marshmallow-Black-Tea-circle.png?v=1687903606&width=239 239w,",
    "name": "Toasted Marshmallow Blend Decaf Black Tea",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Caramel-Snickerdoodle-Dessert-Herbal-Tea-circle.png?v=1687896756&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Caramel-Snickerdoodle-Dessert-Herbal-Tea-circle.png?v=1687896756&width=239 239w,",
    "name": "Caramel Snickerdoodle Herbal Dessert Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Pears-And-Cinnamon-Herbal-Tea-circletrans.png?v=1714075845&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Pears-And-Cinnamon-Herbal-Tea-circletrans.png?v=1714075845&width=239 239w,",
    "name": "Pears and Cinnamon Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Sweet-Spot-Black-circle.png?v=1684540284&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Sweet-Spot-Black-circle.png?v=1684540284&width=239 239w,",
    "name": "Sweet Spot Black Tea (Butterscotch)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Soul-Warmer-Herbal-circle_trans.png?v=1731616874&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Soul-Warmer-Herbal-circle_trans.png?v=1731616874&width=239 239w,",
    "name": "Soul Warmer Herbal Tea (Hazelnut - Chestnut - Caramel)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Butterfly-Pea-Flowers-Herbal-Tea-circle.png?v=1687898836&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Butterfly-Pea-Flowers-Herbal-Tea-circle.png?v=1687898836&width=239 239w,",
    "name": "Butterfly Pea Flowers",
    "price": "$5.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Picard-Blend-Black-circle_trans_e4f2de02-849d-44ff-b9bf-60ce4299efb5.png?v=1719966896&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Picard-Blend-Black-circle_trans_e4f2de02-849d-44ff-b9bf-60ce4299efb5.png?v=1719966896&width=239 239w,",
    "name": "Picard Black Tea Blend (Pecan Earl Grey)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Strawberries-and-Cream-Black-Tea-circle.png?v=1687899016&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Strawberries-and-Cream-Black-Tea-circle.png?v=1687899016&width=239 239w,",
    "name": "Strawberries & Cream Black Tea (with Rose)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Customer_Fave.png?v=1683612370&width=90 90w",
    "name": "Porch Sippin' Pecan Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Afternoon-High-Tea-White-Tea-circletrans.png?v=1714075795&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Afternoon-High-Tea-White-Tea-circletrans.png?v=1714075795&width=239 239w,",
    "name": "Afternoon High Tea White Tea (Peach - Pear)",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Holiday-Embrace-Herbal-circle-trans_5c5295f4-9369-4eeb-a1b5-99020c5f12ec.png?v=1731548644&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Holiday-Embrace-Herbal-circle-trans_5c5295f4-9369-4eeb-a1b5-99020c5f12ec.png?v=1731548644&width=239 239w,",
    "name": "Holiday Embrace Herbal Tea (Cranberry Chai - Orange)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Gingerbread-Chai-Tea-circle-trans.png?v=1732052935&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Gingerbread-Chai-Tea-circle-trans.png?v=1732052935&width=239 239w,",
    "name": "Gingerbread Chai Tea (Gingerbread Spice)",
    "price": "$8.00/oz"
  }
];

const page2 = [
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Blender_sChoicelistinggraphics.png?v=1690651592&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Blender_sChoicelistinggraphics.png?v=1690651592&width=239 239w,",
    "name": "Blender's Choice",
    "price": "$6.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Italian-Wedding-Cake-Black-circle.png?v=1684775699&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Italian-Wedding-Cake-Black-circle.png?v=1684775699&width=239 239w,",
    "name": "Italian Wedding Cake Blend Dessert Tea (Caramel - Coconut - Pecan)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Housewarming-Black-Tea-circle.png?v=1687894455&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Housewarming-Black-Tea-circle.png?v=1687894455&width=239 239w,",
    "name": "Housewarming Blend Black Tea (Vanilla Creme Brulee)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Strawberry Immunity Herbal Tea (Berries - Echinacea)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Banana-Bread-Dessert-Herbal-circle_trans.png?v=1731616931&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Banana-Bread-Dessert-Herbal-circle_trans.png?v=1731616931&width=239 239w,",
    "name": "Banana Bread Herbal Dessert Tea (Chocolate-Chestnut)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Coconut-Macaron-Black-Tea-circle.png?v=1687894177&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Coconut-Macaron-Black-Tea-circle.png?v=1687894177&width=239 239w,",
    "name": "Coconut Macaron Dessert Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Huckleberry-Happiness-Black-Tea-circle_trans.png?v=1731621314&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Huckleberry-Happiness-Black-Tea-circle_trans.png?v=1731621314&width=239 239w,",
    "name": "Huckleberry Happiness Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Stargazer-Caramel-Mate-Chai-circle.png?v=1684775565&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Stargazer-Caramel-Mate-Chai-circle.png?v=1684775565&width=239 239w,",
    "name": "Stargazer Caramel Maté Chai",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Comfort-Blend-Black-Tea-circle-trans.png?v=1729634696&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Comfort-Blend-Black-Tea-circle-trans.png?v=1729634696&width=239 239w,",
    "name": "Comfort Blend Black Tea (Orange - Cinnamon)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Chocolate-Hazelnut-Dessert-circle-trans_270c04ee-7c30-45ee-b4f8-1b457d556949.png?v=1708034276&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Chocolate-Hazelnut-Dessert-circle-trans_270c04ee-7c30-45ee-b4f8-1b457d556949.png?v=1708034276&width=239 239w,",
    "name": "Chocolate Hazelnut Dessert Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Brunch-in-Paris-Black-circle.png?v=1684536092&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Brunch-in-Paris-Black-circle.png?v=1684536092&width=239 239w,",
    "name": "Brunch in Paris Black Tea Blend (Chocolate - Orange)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Sweet-Georgia-Peach-Black-Tea-circle.png?v=1687300535&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Sweet-Georgia-Peach-Black-Tea-circle.png?v=1687300535&width=239 239w,",
    "name": "Sweet Georgia Peach Black Tea (Hint of Caramel - Walnut)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Reading-Nook-Black-circle.png?v=1684542697&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Reading-Nook-Black-circle.png?v=1684542697&width=239 239w,",
    "name": "Reading Nook Tea Blend (Rose - Lavender - Chamomile)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Coconut-A-La-Creme-Black-Tea-circle.png?v=1687898857&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Coconut-A-La-Creme-Black-Tea-circle.png?v=1687898857&width=239 239w,",
    "name": "Coconut A La Creme Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Vanilla-Latte-Black-Tea-circle-trans.png?v=1708636740&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Vanilla-Latte-Black-Tea-circle-trans.png?v=1708636740&width=239 239w,",
    "name": "Vanilla Latte Tea (Cardamom Vanilla Creme)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Uplifting-Coconut-Chai-Tea-circle.png?v=1687899070&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Uplifting-Coconut-Chai-Tea-circle.png?v=1687899070&width=239 239w,",
    "name": "Uplifting Coconut Chai",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Queen_s-Blend-Green-circle-trans.png?v=1711584953&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Queen_s-Blend-Green-circle-trans.png?v=1711584953&width=239 239w,",
    "name": "Queen's Blend Green Tea (Lemon Crème Earl Grey)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Caramel-Almond-Black-Tea-circle_trans.png?v=1732915125&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Caramel-Almond-Black-Tea-circle_trans.png?v=1732915125&width=239 239w,",
    "name": "Caramel Almond Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Magical-Butterfly-Herbal-circle.png?v=1684775730&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Magical-Butterfly-Herbal-circle.png?v=1684775730&width=239 239w,",
    "name": "Magical Butterfly Herbal Tea (Butterfly Pea Flower / Berries)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Dragonfruit-Desire-Herbal-Tea-circle_trans.png?v=1721773738&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Dragonfruit-Desire-Herbal-Tea-circle_trans.png?v=1721773738&width=239 239w,",
    "name": "Dragonfruit Desire Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Decaf-No-Obligations-circle-trans.png?v=1708636777&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Decaf-No-Obligations-circle-trans.png?v=1708636777&width=239 239w,",
    "name": "No Obligations Decaf Black Tea (Hazelnut - Almond - Cinnamon)",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Fog Cutter Black Tea (Irish Breakfast w-Hint of Lemon)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Pineapple-Pop-Herbal-Tea-circle.png?v=1687900509&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Pineapple-Pop-Herbal-Tea-circle.png?v=1687900509&width=239 239w,",
    "name": "Pineapple Pop Herbal Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Candy-Cane-Herbal-Tea-circle-trans.png?v=1732048534&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Candy-Cane-Herbal-Tea-circle-trans.png?v=1732048534&width=239 239w,",
    "name": "Candy Cane Herbal Tea (Vanilla - Peppermint)",
    "price": "$8.00/oz"
  }
];

let page3 = [
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Halloween-Blend-Black-circle.png?v=1684542662&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Halloween-Blend-Black-circle.png?v=1684542662&width=239 239w,",
    "name": "Halloween Blend Black Tea (Vanilla - Caramel)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Portland Rose City Chai (Blackberry - Rose)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Easy-Like-Sunday-Morning-Herbal-circle-trans.png?v=1708034727&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Easy-Like-Sunday-Morning-Herbal-circle-trans.png?v=1708034727&width=239 239w,",
    "name": "Easy Like Sunday Morning Herbal Tea (Chocolate - Lavender)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Blackberry Mojito Black Tea (Lime - Maple - Spearmint)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Mindful-Morning-Black-Tea-circle_trans_b38a2b9a-6026-4f9f-a100-499f4f524780.png?v=1719349423&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Mindful-Morning-Black-Tea-circle_trans_b38a2b9a-6026-4f9f-a100-499f4f524780.png?v=1719349423&width=239 239w,",
    "name": "Mindful Morning Tea Blend (Earl Grey)",
    "price": "From $8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Cuddletime-Herbal-circle.png?v=1684538209&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Cuddletime-Herbal-circle.png?v=1684538209&width=239 239w,",
    "name": "Cuddletime Herbal Tea (Chamomile - Mint)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Coconut-Ginger-Soother-Herbal-circle.png?v=1684776001&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Coconut-Ginger-Soother-Herbal-circle.png?v=1684776001&width=239 239w,",
    "name": "Coconut Ginger Soother Herbal Tea (Apple-Cinnamon)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Maple-Pecan-Black-Tea-circle_trans.png?v=1731548206&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Maple-Pecan-Black-Tea-circle_trans.png?v=1731548206&width=239 239w,",
    "name": "Maple Pecan Black-Oolong Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Decaf-Comfort-Blend-Black-Tea-circle.png?v=1687900043&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Decaf-Comfort-Blend-Black-Tea-circle.png?v=1687900043&width=239 239w,",
    "name": "Comfort Blend Decaf Black Tea (Orange - Cinnamon)",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Night-Cap-Herbal-Tea-circle.png?v=1687225319&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Night-Cap-Herbal-Tea-circle.png?v=1687225319&width=239 239w,",
    "name": "Night Cap Herbal Tea (Valerian Root - Peppermint)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/House-Blend-Black-Tea-circle.png?v=1687225187&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/House-Blend-Black-Tea-circle.png?v=1687225187&width=239 239w,",
    "name": "House Blend Black Tea (Creamy Vanilla English Breakfast)",
    "price": "From $8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Vanilla-Creme-Herbal-circle.png?v=1684775623&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Vanilla-Creme-Herbal-circle.png?v=1684775623&width=239 239w,",
    "name": "Vanilla Creme Herbal Tea",
    "price": "$6.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Garden-Grove-Green-Tea-circle.png?v=1687225084&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Garden-Grove-Green-Tea-circle.png?v=1687225084&width=239 239w,",
    "name": "Garden Grove Green Tea (Jasmine - Cherry)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Delightful-Morning-Black-Tea-circle.png?v=1687894279&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Delightful-Morning-Black-Tea-circle.png?v=1687894279&width=239 239w,",
    "name": "Delightful Morning Blend (Earl Grey Lavender)",
    "price": "From $8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Maple-Ginger-Butterscotch-Black-circle.png?v=1684775499&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Maple-Ginger-Butterscotch-Black-circle.png?v=1684775499&width=239 239w,",
    "name": "Maple Ginger Butterscotch Black Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Just-Elderberries-circle.png?v=1684534723&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Just-Elderberries-circle.png?v=1684534723&width=239 239w,",
    "name": "Just Elderberry Herbal Tea",
    "price": "$5.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Rainy-Day-Puerh-circle.png?v=1684778552&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Rainy-Day-Puerh-circle.png?v=1684778552&width=239 239w,",
    "name": "Rainy Day Puerh (Sweet 'n' Spicy)",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Abundance-Blend-Green-circle.png?v=1684533478&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Abundance-Blend-Green-circle.png?v=1684533478&width=239 239w,",
    "name": "Abundance Blend Green Tea (Passionfruit - Elderflower)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Calm-Chamomile-Herbal-Tea-circle.png?v=1687896711&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Calm-Chamomile-Herbal-Tea-circle.png?v=1687896711&width=239 239w,",
    "name": "Calm Chamomile Bloom Herbal Tea (Rose - Lavender)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Breakfast-in-Bed-Black-circle.png?v=1684777262&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Breakfast-in-Bed-Black-circle.png?v=1684777262&width=239 239w,",
    "name": "Breakfast in Bed Black Tea (Blackberry - Hazelnut)",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Red-Velvet-Chocolate-Puerh-circle-trans.png?v=1708034556&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Red-Velvet-Chocolate-Puerh-circle-trans.png?v=1708034556&width=239 239w,",
    "name": "Red Velvet Chocolate Puerh Dessert Tea",
    "price": "$9.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Staff_Fave.png?v=1683612079&width=90 90w",
    "name": "Toasted Nut Brulee Oolong Tea",
    "price": "$8.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Bestseller-Sampler-Plum-Deluxe-Listing-Graphic_2.png?v=1730870761&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Bestseller-Sampler-Plum-Deluxe-Listing-Graphic_2.png?v=1730870761&width=239 239w,",
    "name": "Best Sellers Sampler Set",
    "price": "$14.00/oz"
  },
  {
    "srcset": "//www.plumdeluxe.com/cdn/shop/files/Mango-Apricot-Green-circle.png?v=1684538325&width=165 165w,//www.plumdeluxe.com/cdn/shop/files/Mango-Apricot-Green-circle.png?v=1684538325&width=239 239w,",
    "name": "Mango-Apricot Green Tea",
    "price": "$8.00/oz"
  }
];

const priced = [...page1, ...page2, ...page3 ]
  .map(({name, price, srcset}) => ({
    name,
    img:`https:${srcset.split('?')[0]}`,
    price: Number(price.split(/\$|\//g)[1])
  }))
  .sort((a,b) => a.price - b.price);

export const minPrice = priced.map(({price}) => (price))
  .reduce((a,b) => Math.min(a,b));

const varietyOptions = priced.reduce(({options, upcharge, imgs}, {name, img, price}) => {
  options.push(name);
  upcharge.push(price - minPrice);
  imgs.push(img);
  return {
    options,
    upcharge,
    imgs,
  }
}, { options: [], imgs: [], upcharge: []});

export const variety = {
  count: 3,
  name: 'Variety',
  ...varietyOptions,
};
